import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private http: HttpClient,
    private httpHelper: HttpHelperService
  ) { }

  onboardClient(data): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Clients/CreateOnBoardingClient`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

  updateOnboardClient(data): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl('/api/Clients/UpdateClient');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put(apiUrl, data, requestOptions); 
  }
  
  getClientById(id): Observable<any> {
    let params = new HttpParams()
      .set('Id', id)
    const apiUrl = this.httpHelper.getApiUrl('/api/Clients/GetClientById');
    return this.http.get(apiUrl, {params: params});
  }

  checkEmailFBandDB(email): Observable<any>{
    let params = new HttpParams()
      .set('email', email)
    const apiUrl = this.httpHelper.getApiUrl('/api/Users/CheckEmailInFBandDB');
    return this.http.get(apiUrl, {params: params});
  }
  
}
